import { useDonationToasts } from '../hooks';

/**
 * Component that enables global donation toast notifications.
 * Must be rendered inside RealtimeProvider.
 */
function DonationToasts(): null {
  useDonationToasts();
  return null;
}

export default DonationToasts;
